import * as SerializerLib from "jsonapi-serializer";

import { serializeError } from "../base.serializer";

const JSONAPISerializer = SerializerLib.Serializer;

const opts = {
  attributes: ["login", "email", "toolType", "toolId"]
};

export const serialize = (data) => {
  try {
    const Serializer = new JSONAPISerializer("unverified-user", opts);
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};
